import UserId from "../../state/UserId";
import type { AccountOwnerDto } from "../../services/UserService";
import type { AccountOwner } from "../../types/AccountOwner";

export const toAccountOwner = (dto: AccountOwnerDto): AccountOwner => ({
  id: UserId.from(dto.id),
  firstName: dto.firstName,
  lastName: dto.lastName,
  emailAddress: dto.emailAddress,
});
